module.exports = __webpack_public_path__ + "img/account-icon-active.02be5fa4.svg";